// English strings for the store's screens with the kitchen flow on (batch 4,
// lane store): the grouped tabs, the quiet "no stock levels" note, the To do
// list and "Approve & send what we have". One table so an Urdu one can be
// dropped in later. Plain words: many readers are low-literacy.

export const ST = {
  tabs: {
    todo: 'To do',
    stock: 'Stock',
    buying: 'Buying',
    count: 'Count',
    more: 'More',
  },
  buying: {
    purchasing: 'Purchasing',
    vendors: 'Vendors',
  },
  more: {
    alerts: 'Alerts',
    history: 'History',
    reports: 'Reports',
    locations: 'Locations',
  },
  recordPurchase: 'Record a purchase',

  noLevels: (n: number) => `${n} item${n === 1 ? ' has' : 's have'} no stock levels yet,`,
  noLevelsRest: 'so low-stock warnings and "What to buy" stay quiet for them.',
  setLevels: 'Set levels',

  todo: {
    sortedBy: 'Sorted by when the kitchen needs it',
    filterNow: 'Waiting on the store',
    filterOpen: 'Still open',
    filterAll: 'All',
    neededToday: 'Needed today',
    neededTomorrow: 'Needed tomorrow',
    neededOn: (day: string) => `Needed ${day}`,
    wasNeeded: (day: string) => `Was needed ${day}`,
    noDate: 'No date given',
    missingTitle: 'Missing on the way',
    missingHint: 'Write it off with a manager PIN',
    returnTitle: 'Sent back to the store',
    items: (n: number) => `${n} item${n === 1 ? '' : 's'}`,
    from: (name: string) => `From ${name}`,
    chipNew: 'New',
    chipToSend: (n: number) => `${n} still to send`,
    chipMissingManager: 'Missing — needs a manager',
    chipMissingAdmin: 'Missing — write it off',
    chipReturn: 'Check the return',
    loadError: 'Could not load the requests.',
    retry: 'Try again',
    emptyTodo: 'Nothing to do — every request is dealt with.',
    emptyList: 'No requests here yet.',
    pick: 'Pick a request to see it.',
  },

  send: {
    title: 'Approve & send what we have',
    restTitle: 'Send the rest',
    item: 'Item',
    asked: 'Asked',
    stillToSend: 'Still to send',
    storeHas: 'Store has',
    sendNow: 'Send now',
    sendLabel: (item: string) => `Send ${item}`,
    nothingToSend: 'Nothing to send',
    onlyShort: (has: string, short: string, unit: string) => `Only ${has} ${unit} — ${short} ${unit} short`,
    noneShort: (short: string, unit: string) => `None in stock — ${short} ${unit} short`,
    expiredNotCounted: (qty: string, unit: string, when: string) => `${qty} ${unit} expired on ${when} — not counted.`,
    throwAway: 'Throw it away',
    moreInStock: (n: number) => `+ ${n} more item${n === 1 ? '' : 's'}, all in stock`,
    short: (list: string) => `Short: ${list}`,
    shortHelp: 'The kitchen will see these as "still to come".',
    approveSend: (n: number, m: number) => `Approve & send ${n} of ${m} item${m === 1 ? '' : 's'}`,
    approveOnly: 'Approve — nothing to send yet',
    approveSendOk: 'Approved and sent to the kitchen',
    approveOnlyOk: 'Approved — send the stock when it comes in',
    sendBack: 'Send back with a reason',
    sendBackReason: 'Why are you sending it back? (required)',
    sendBackOk: 'Sent back to the kitchen',
    cancel: 'Cancel',
    sendRest: (n: number) => `Send ${n} item${n === 1 ? '' : 's'} now`,
    nothingYet: 'Nothing to send yet',
    markNotAvailable: 'Mark the rest as not available',
    notAvailableReason: 'Why? (e.g. not in stock)',
    notAvailableSave: 'Save',
    moreThanAsked: (qty: string, unit: string) => `Only ${qty} ${unit} was asked for`,
    moreThanOwed: (qty: string, unit: string) => `Only ${qty} ${unit} is still to send`,
    moreThanStore: (qty: string, unit: string) => `The store has only ${qty} ${unit} in date`,
    enterNumber: 'Enter a number',
  },

  // Adjust / Issue with the kitchen flow on (Batch 5 lane stock): they work on
  // the store's shelf only, as the server does.
  storeShelf: {
    has: (place: string, qty: string, unit: string) => `${place} has ${qty} ${unit}`,
    checking: (place: string) => `Checking what ${place} has…`,
    notMore: (place: string, qty: string, unit: string) => `${place} has only ${qty} ${unit}. You cannot take out more than that.`,
    kitchenHint: 'This only changes the store. To correct the kitchen, use Count or Waste.',
  },
} as const
